import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Chart as ChartJS, registerables } from "chart.js";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import dashboardService from "../../services/dashboard-service";
import sectionService from "../../services/section-service";
import { registerLocale } from "react-datepicker";
import { es } from "date-fns/locale/es";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Divider, Spin } from "antd";
import { CloudDownloadOutlined } from "@ant-design/icons";
import BarchartDay from "../DashBoard/BarchartDay";
import moment from "moment/moment";
import 'moment/locale/es';
import config from "../../config/config";
import Select from "react-select";
import LineChart from "../DashBoard/LineChart";
import BarLineLineChartV2 from "../DashBoard/BarLineLineChartV2";



// Registrar componentes para Chart.js
ChartJS.register(...registerables);

const DashboardFirstApplicationsMonth = () => {


  const chartOneRef = useRef(null);
  const chartTwoRef = useRef(null);
  const chartThreeRef = useRef(null);
  const chartFourRef = useRef(null);
  const chartFiveRef = useRef(null);


  const [showLineValues, setShowLineValues] = useState(true)
  const [expandChats, setExpandCharts] = useState(false)

  ///Aplicaciones por dia
  const [lotId, setLotId] = useState("0");
  const [farmId, setFarmId] = useState("0");


  ////CONSTANTES DE COORRELACION////////////////////////

  const [totalFirst, setTotalFirst] = useState(0)

  const [serieFirstHectareLot, setSerieFirstHectareLot] = useState([])
  const [listFirstHectareLot, setListFirstHectareLot] = useState([])

  const [serieFirstHectareMonth, setSerieFirstHectareMonth] = useState([])
  const [listFirstHectareMonth, setListFirstHectareMonth] = useState([])


  const [serieFirstMonth, setSerieFirstMonth] = useState([])
  const [listFirstMonth, setListFirstMonth] = useState([])

  const [serieFirstApplicationDay, setSerieFirstApplicationDay] = useState([])
  const [listFirstApplicationDay, setListFirstApplicationDay] = useState([])

  const [serieFirstApplicationLot, setSerieFirstApplicationLot] = useState([])
  const [listFirstApplicationLot, setListFirstApplicationLot] = useState([])
  const [listLineAveragePalm, setListLineAveragePalm] = useState([]);



  const [dateList, setDateList] = useState([]);
  const [numPalmList, setNumPalmList] = useState([]);
  const [averageList, setAverageList] = useState([]);





  /*registerLocale("es", es);
  const start_date = moment().add(-config.DAYS_LESS, 'd').startOf("day").toDate();
  const end_date = moment().endOf("day").toDate();*/


  registerLocale("es", es);
  const start_date = moment().subtract(6, 'month').startOf('month').toDate();
  const end_date = moment().subtract(1, 'month').endOf('month').toDate();


  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);

  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);
  const [sectionId, setSectionId] = useState("0");


  const [type, setType] = useState("$totalFirst");
  const [labelTypeSelected, setLabelTypeSelected] = useState("Primera aplicación");
  const [labelType, setLabelType] = useState("Primera aplicación");
  const listType = [
    { _id: "$totalFirst", name: "Primera aplicación", label: "Primera aplicación" },
    { _id: "$totalSecond", name: "Segunda aplicación", label: "Segunda aplicación" },
    { _id: "$totalThird", name: "Tercera aplicación", label: "Tercera aplicación" },
    { _id: "$total", name: "Total de aplicaciones", label: "Total de aplicaciones" }
  ]


  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  const [options, setOptions] = useState([])
  const [selectedLotes, setSelectedLotes] = useState([]);
  const handleSelectChange = (selectedOptions) => {
    setSelectedLotes(selectedOptions || []);
  };

  // Estilos personalizados  
  const customStyles = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#CBEDFE",
      fontFamily: "inherit",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
    menu: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
  };
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////


  const formatDate = (dateString) => {
    return moment(dateString).locale('es').format('DD MMM');
  };

  const formatMonth = (yearMonth) => {
    const [year, month] = yearMonth.split("-").map(Number);
    const date = new Date(year, month - 1);
    return new Intl.DateTimeFormat("es-ES", { month: "short", year: "numeric" }).format(date);
  };

  const formatMonthYearIntl = (yearMonth) => {
    const [year, month] = yearMonth.split("-").map(Number);
    const date = new Date(year, month - 1);
    return new Intl.DateTimeFormat("es-ES", { month: "short", year: "numeric" }).format(date);
  };

  const changeStateShowValues = (e) => {
    setShowLineValues(!e.target.checked)
  }

  const changeExpand = (e) => {
    setExpandCharts(e.target.checked)
  }

  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
      //setValue("farm",0)
    }
  };

  const getListSection = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setFarmId(code);
    if (code == "0") {
      setListSection(escoja);
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
    }
  };

  const getLisLots = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setSectionId(code);
    if (code == "0") {
      setListLots(escoja);
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      const newOptions = sortedItems.map((lote) => ({
        value: lote._id,
        label: lote.name,
      }));
      setOptions(newOptions)
    }
  };






  ///PROMEDIO POR PALMA  
  const averageByPalmMonth = async () => {
    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setListLineAveragePalm([])
    const result = await dashboardService.averageByPalmMonth(start, end, farmId, lotId, sectionId, selectedLotes, type);
    let list = [];


    setDateList([])
    setNumPalmList([])
    setAverageList([])
    let dateList = [];
    let numPalm = [];
    let averageList = [];


    if (result) {
      result.map((item) => {
        const month = formatMonth(item.date);
        const totalPalms = item.totalPalms;
        const cantidad = item.average;
        const rounded = cantidad.toFixed(1);


        dateList.push(month)
        numPalm.push(totalPalms)
        averageList.push(rounded)

        list.push({ value: [month, rounded] })



      });
    }
    setListLineAveragePalm(list)

    setDateList(dateList)
    setNumPalmList(numPalm)
    setAverageList(averageList)
  };






  /// APLICACIONES POR  MES
  const firstApplicationMonth = async () => {

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setSerieFirstMonth([])
    setListFirstMonth([])
    let counter = 0
    const result = await dashboardService.firstApplicationMonth(start, end, farmId, lotId, sectionId, selectedLotes, type);
    let listMonth = [];
    let listApp = [];
    if (result) {
      result.map((item) => {
        const month = formatMonth(item._id);
        const app_1 = item.totalApplicationsType1;
        counter = counter + app_1
        listMonth.push(month)
        listApp.push(app_1)
      });
    }
    setTotalFirst(counter)
    setSerieFirstMonth(listMonth)
    setListFirstMonth(listApp)
  };





  /// APLICACIONES POR HECTAREA MES
  const firstApplicationHectareMonth = async () => {

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setSerieFirstHectareMonth([])
    setListFirstHectareMonth([])
    const result = await dashboardService.firstApplicationHectareMonth(start, end, farmId, lotId, sectionId, selectedLotes, type);
    let listMonth = [];
    let listApp = [];
    if (result) {
      result.map((item) => {
        const month = formatMonth(item.yearMonth);
        const app_1 = item.avgApplicationsPerHectare.toFixed(1);
        listMonth.push(month)
        listApp.push(app_1)
      });
    }
    setSerieFirstHectareMonth(listMonth)
    setListFirstHectareMonth(listApp)
  };







  const loadDashBoard = () => {
    averageByPalmMonth()
    firstApplicationHectareMonth()
    firstApplicationMonth()
    setLabelType(labelTypeSelected)
  };

  useEffect(() => {
    getLisFarm();
    loadDashBoard()
  }, []);

  const {
    register,
    formState: { errors },
  } = useForm();



  const cardStyle = {
    padding: "20px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    borderRadius: "10px",
    backgroundColor: "#fff",
  };

  const saveAsImage = (chartRef, title) => {
    if (chartRef.current) {
      const echartsInstance = chartRef.current.getEchartsInstance();
      const imgData = echartsInstance.getDataURL({
        type: "jpeg", // Formato de la imagen ('png', 'jpeg')
        pixelRatio: 2, // Relación de píxeles (mayor = imagen de mayor calidad)
        backgroundColor: "#fff", // Fondo de la imagen
      });

      // Crear un enlace para descargar la imagen
      const link = document.createElement("a");
      link.href = imgData;
      link.download = title; // Nombre del archivo
      link.click();
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Dashboard aplicación por tipos mensual</Divider>
      </div>
      <div className="row">
        <div className="col-12">
          <form className="form-react">
            <div className="row mb-3">


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Finca</label>
                <select
                  className="form-control text-secondary"
                  {...register("farm")}
                  onChange={(e) => getListSection(e)}
                >
                  {listFarms.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-12 col-sm-3">
                <label className="text-secondary fw-bold">Sección</label>
                <select
                  className="form-control text-secondary"
                  {...register("section")}
                  onChange={(e) => getLisLots(e)}
                >
                  {listSection.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>







              <div className="col-6 col-sm-2">
                <label className="text-secondary fw-bold">Desde</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control text-secondary"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>

              <div className="col-6 col-sm-2">
                <label className="text-secondary fw-bold">Hasta</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control 
                text-secondary"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                />
              </div>

              <div className="col-12 col-sm-2">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <button
                  className="btn btn-primary w-100"
                  type="button"
                  onClick={() => loadDashBoard()}
                >
                  <i className="bi bi-search fa-lg m-2" /> Cargar gráficos
                </button>
              </div>


              <div className="col-12 col-sm-6">
                <label className="text-secondary fw-bold">Lotes</label>
                <Select
                  isMulti
                  options={options}
                  value={selectedLotes}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  placeholder="Selecciona lotes..."
                />
              </div>

              <div className=" col-4">
                <label className="text-secondary fw-bold">Tipo</label>
                <select
                  className="form-control text-secondary"
                  {...register("type")}
                  onChange={(e) => {
                    const value = e.target.value
                    console.log(e)
                    setType(value)
                    const selected = listType.find(a => a._id == value)
                    setLabelTypeSelected(selected.label)
                  }}
                >
                  {listType.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="mt-2 col-6 col-sm-2"><label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" onChange={(e) => changeExpand(e)} />
                  <label className="form-check-label" for="flexSwitchCheckDefault">Minimizar grafica</label>
                </div>
              </div>

            </div>



          </form>
        </div>





        <div className="col-12 col-sm-12 text-center ">
          <div className="shadow p-1 mb-3 bg-white rounded">
            <label style={{ fontSize: "20px", fontWeight: "bold", color: "#00D9A3" }}>Inflorescencias {labelType}: </label>
            <label className="m-2 text-secondary" style={{ fontSize: "20px", fontWeight: "bold" }}>{totalFirst.toLocaleString()}</label>
          </div>
        </div>


        <div className={expandChats ? "col-12 d-none" : "col-12 col-sm-12 mt-2 d-none"}>
          <div style={cardStyle}>
            <LineChart
              decimals={1}
              valueY={listLineAveragePalm}
              chartRef={chartOneRef}
              title="Aplicaciones / palma"
              subTitle="Promedio de aplicaciones realizadas por palma"
              seriesTitle="Aplicaciones"
              showSerieValue={showLineValues}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartOneRef, "prom-aplicaciones-palma.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>


        <div className={expandChats ? "col-6 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarchartDay
              chartRef={chartTwoRef}
              title={`${labelType} - mes`}
              nameLine="Hectáreas"
              nameBar="Aplicaciones"
              subTitle="Total de inflorescencias por mes"
              showSerieValue={showLineValues}
              valuesX={serieFirstMonth}
              valuesY={listFirstMonth}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartTwoRef, "aplicaciones-mes.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>







        <div className={expandChats ? "col-6 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarchartDay
              chartRef={chartThreeRef}
              title={`${labelType} - hectárea - mes`}
              nameLine="Hectáreas"
              nameBar="Aplicaciones"
              subTitle="Promedio de inflorescencias por hectárea agrupado mes"
              showSerieValue={showLineValues}
              valuesX={serieFirstHectareMonth}
              valuesY={listFirstHectareMonth}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartThreeRef, "aplicaciones-hectarea-mes.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>





        <div className={expandChats ? "col-6 mt-2" : "col-12 col-sm-12 mt-2"}>
          <div style={cardStyle}>
            <BarLineLineChartV2
              decimals={2}
              chartRef={chartFourRef}
              title={`${labelType} / Palma`}
              subTitle=""
              nameLine="Aplicaciones/palma"
              nameLine2=""
              nameBar="Palmas"
              categories={dateList}
              applications={numPalmList}
              hectares={averageList}
            />
            <Button
              color="default"
              variant="outlined"
              onClick={() => saveAsImage(chartFourRef, "promedios-aplicacion-palma.jpeg")}
            >
              <CloudDownloadOutlined className="fa-lg" />Descargar
            </Button>
          </div>
        </div>





      </div>
    </div>
  );
};

export default DashboardFirstApplicationsMonth;
